import { Box, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { useHistory, useRouteMatch } from "react-router-dom";
import modules from "../modules/modules";
import { GifColors } from "../../../theme";

const useStyles = makeStyles((theme) => ({
  selectedTab: {
    backgroundColor: theme.palette.gif.blue.color,
    color: "#ffffff",
  },
  tabsBox: {
    display: "flex",
  },
  tabBox: {
    width: "25%",
    display: "flex",
    height: 60,
    marginRight: 1,
    marginLeft: 1,
    backgroundColor: "#ffffff",
    borderRadius: 5,
    justifyContent: "space-evenly",
    alignItems: "center",
    border: "1px solid #e7e7e7",
    cursor: "pointer",
    "&:hover": {
      opacity: 1,
      backgroundColor: GifColors.lightGray,
    },
  },
  activeTab: {
    color: "#ffffff",
    cursor: "default",
    backgroundColor: theme.palette.gif.blue.color,
    "&:hover": {
      backgroundColor: theme.palette.gif.blue.color,
    },
  },
}));

export default function MainTabs({ baseurl }) {
  const history = useHistory();
  const classes = useStyles();

  const IsActive = (route) => {
    const match = useRouteMatch({
      path: `${baseurl}${route}`,
      strict: false,
    });
    if (!match) return false;
    return true;
  };

  const handleOnClick = (module) => {
    history.push(`${baseurl}${module.path}`);
  };

  return (
    <Box className={classes.tabsBox}>
      {modules.map((m) => (
        <Box
          onClick={() => handleOnClick(m)}
          key={m.path}
          className={`${classes.tabBox} ${
            IsActive(m.path) ? classes.activeTab : ""
          }`}
        >
          <Typography>{m.headerText}</Typography>
        </Box>
      ))}
    </Box>
  );
}
